import { useState, useCallback } from "react"
import type { DivergenceFile } from "../types"
import { ItemType } from "../types/shared"
import { useLazyGetEntityAuditHistoryQuery, type AuditLogResponse } from "@/services/conciliation/audit-log"
import { AUDIT_ENTITY_TYPES, type AuditEntityType } from "@/constants/conciliation/audit.constants"

// Mapeamento de entity_type baseado no tipo do item
const getEntityType = (itemType: ItemType): AuditEntityType => {
  return itemType === ItemType.DIVERGENCE
    ? AUDIT_ENTITY_TYPES.EMAIL_SOLICITATION_DIVERGENCE
    : AUDIT_ENTITY_TYPES.EMAIL_SOLICITATION_NSU
}

export const useModals = () => {
  const [selectedFile, setSelectedFile] = useState<DivergenceFile | null>(null)
  const [isFileViewerOpen, setIsFileViewerOpen] = useState(false)
  const [isRejectConfirmationOpen, setIsRejectConfirmationOpen] = useState(false)
  const [isSpecialConfirmationOpen, setIsSpecialConfirmationOpen] = useState(false)
  const [selectedItemForHistory, setSelectedItemForHistory] = useState<any>(null)
  const [auditHistoryData, setAuditHistoryData] = useState<AuditLogResponse | null>(null)
  const [isAuditHistoryLoading, setIsAuditHistoryLoading] = useState(false)

  const [fetchAuditHistory] = useLazyGetEntityAuditHistoryQuery()

  const openFileViewer = useCallback((file: DivergenceFile) => {
    setSelectedFile(file)
    setIsFileViewerOpen(true)
  }, [])

  const closeFileViewer = useCallback(() => {
    setIsFileViewerOpen(false)
    setSelectedFile(null)
  }, [])

  const openRejectConfirmation = useCallback(() => {
    setIsRejectConfirmationOpen(true)
  }, [])

  const closeRejectConfirmation = useCallback(() => {
    setIsRejectConfirmationOpen(false)
  }, [])

  const openSpecialConfirmation = useCallback(() => {
    setIsSpecialConfirmationOpen(true)
  }, [])

  const closeSpecialConfirmation = useCallback(() => {
    setIsSpecialConfirmationOpen(false)
  }, [])

  const openHistoryModal = useCallback(async (item: any) => {
    setSelectedItemForHistory(item)
    setIsAuditHistoryLoading(true)
    setAuditHistoryData(null)

    // Buscar audit history se tiver review_id
    if (item?.review_id) {
      try {
        const entityType = getEntityType(item.type)
        const result = await fetchAuditHistory({
          entity_type: entityType,
          entity_id: String(item.review_id),
        }).unwrap()
        setAuditHistoryData(result)
      } catch (error) {
        console.warn('Erro ao buscar audit history, usando fallback:', error)
        setAuditHistoryData(null)
      }
    }
    setIsAuditHistoryLoading(false)
  }, [fetchAuditHistory])

  const closeHistoryModal = useCallback(() => {
    setSelectedItemForHistory(null)
    setAuditHistoryData(null)
    setIsAuditHistoryLoading(false)
  }, [])

  return {
    selectedFile,
    isFileViewerOpen,
    isRejectConfirmationOpen,
    isSpecialConfirmationOpen,
    selectedItemForHistory,
    auditHistoryData,
    isAuditHistoryLoading,
    openFileViewer,
    closeFileViewer,
    openRejectConfirmation,
    closeRejectConfirmation,
    openSpecialConfirmation,
    closeSpecialConfirmation,
    openHistoryModal,
    closeHistoryModal
  }
}
